import { gql } from '@apollo/client';
import { INSTITUTION, INTERVENTION, PROGRAMME, REPORT, SERVICE_PROVIDER, USER } from '../fragments';

export const UPSERT_FUNDER_REPORT = gql`
  mutation upsertFunderReport($input: UpsertReportInput!) {
    report: upsertFunderReport(input: $input) {
      ...report
      createdBy {
        ...user
      }
      institutions {
        ...institution
      }
      interventions {
        ...intervention
      }
      programmes {
        ...programme
      }
      serviceProvider {
        ...serviceProvider
      }
    }
  }
  ${REPORT}
  ${USER}
  ${INSTITUTION}
  ${INTERVENTION}
  ${PROGRAMME}
  ${SERVICE_PROVIDER}
`;
